// extracted by mini-css-extract-plugin
export default {"Bage__Wrapper":"Bage_Bage__Wrapper__QvpZH"};